<template>
  <div class="BaseArticlePage">
    <BaseCommonPage>
      <div class="container-fluid fun_container area_funcontents">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <FuncSearchGallery />

              <h1 class="thema_func">
                <span class="glyphicon glyphicon-tag"></span>
                <LabelFunMessage fcontId="0" msgkey="170" />
              </h1>


              <p class="description">
                <LabelFunMessage fcontId="0" msgkey="171" />
              </p>

            </div>
          </div>

        </div>
      </div>

      <div class="container fun_top">
        <p class="text-center">
          <FuncSearchGalleryTop>
            <LabelFunMessage fcontId="0" msgkey="14" />&nbsp;&raquo;
          </FuncSearchGalleryTop>
        </p>
      </div>

      <InstaGalleryButton />
      
    </BaseCommonPage>
  </div>
</template>

<script>
import BaseCommonPage from "./BaseCommonPage";
import FuncSearchGallery from "../components/FuncSearchGallery";
import LabelFunMessage from "../components/LabelFunMessage";
import InstaGalleryButton from "../components/InstaGalleryButton";
import FuncSearchGalleryTop from "../components/FuncSearchGalleryTop";

export default {
  name: "EndPremiumNengaPage",
  components: {
    BaseCommonPage,
    LabelFunMessage,
    FuncSearchGallery,
    InstaGalleryButton,
    FuncSearchGalleryTop,
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
   
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['0-168'],
      meta: [
        {
          name: "description",
          content:
            this.$store.state.messages.messages['0-169'],
        },
      ],
    };
  },
};
</script>

<style scoped>
.thema_func {
  line-height: 1.4;
}

.area_funcontents p.description {
  line-height: 1.8;
}


.title-func {
  line-height: 1.4;
}
</style>
